import { render, staticRenderFns } from "./releaseActivities2.vue?vue&type=template&id=a73c3610&scoped=true&"
import script from "./releaseActivities2.vue?vue&type=script&lang=js&"
export * from "./releaseActivities2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73c3610",
  null
  
)

export default component.exports